import api from 'Application/api/api';

const editRfep = (signal, values) =>
	api.put('/tenders', values, {
		signal,
	});

export default editRfep;
